import { COOKIE_KEYS } from './constants';
import { Cookie } from './types';
import { getCookieValue } from './getCookieValue';

const { LANG_USER } = COOKIE_KEYS;
export const { LANG_SELLER } = COOKIE_KEYS;

export function getUserLang(cookie: Cookie): string | null {
    return getCookieValue(cookie, LANG_USER);
}

export function getSellerLang(cookie: Cookie): string | null {
    return getCookieValue(cookie, LANG_SELLER);
}
